import { useRouter } from "next/router";
import React from "react";

export const useIsPageLoading = () => {
  const [isPageLoading, isPageLoadingSet] = React.useState(false);
  const router = useRouter();

  React.useEffect(() => {
    const handleStart = () => isPageLoadingSet(true);
    const handleComplete = () => isPageLoadingSet(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router]);

  return { isPageLoading };
};
